{
  "id": "campaign-142",
  "name": "Honey Vale",
  "seed": "campaign:142",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "..........mmT.....",
    "..x...........T...",
    "..................",
    "....T.............",
    "..................",
    "..........#.......",
    "..T..h.T......h...",
    ".....mmm.......T..",
    "......mT........#.",
    "...h.h............",
    "...........Y.....h",
    "m..x..............",
    "mm..T.............",
    "..#...............",
    "...........x......",
    "..x.....x.........",
    "..........h.......",
    "T.......h........S"
  ],
  "critters": [
    {
      "kind": "deer",
      "x": 6,
      "y": 12
    },
    {
      "kind": "deer",
      "x": 6,
      "y": 11
    },
    {
      "kind": "deer",
      "x": 1,
      "y": 5
    },
    {
      "kind": "deer",
      "x": 1,
      "y": 4
    },
    {
      "kind": "fox",
      "x": 13,
      "y": 8
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 5,
      "y": 8
    },
    {
      "kind": "gas",
      "x": 17,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 17
    },
    {
      "kind": "coin",
      "x": 12,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 8
    },
    {
      "kind": "repair",
      "x": 11,
      "y": 1
    }
  ],
  "hills": [
    {
      "x": 3,
      "y": 4,
      "w": 5,
      "h": 5
    }
  ],
  "generatorVersion": 3,
  "level": 142,
  "biome": "meadow",
  "par": {
    "reel": 11247,
    "push": 9629,
    "selfPropelled": 9048,
    "tractor": 7405,
    "zeroTurn": 6287,
    "fairway": 3604
  },
  "goldTime": {
    "reel": 11247,
    "push": 9629,
    "selfPropelled": 9048,
    "tractor": 7405,
    "zeroTurn": 6287,
    "fairway": 3274
  },
  "routeTries": {
    "par": {
      "reel": 7,
      "push": 2,
      "selfPropelled": 0,
      "tractor": 10,
      "zeroTurn": 0,
      "fairway": 3
    },
    "gold": {
      "reel": 7,
      "push": 2,
      "selfPropelled": 0,
      "tractor": 10,
      "zeroTurn": 0,
      "fairway": 31
    }
  }
}
